import { router } from 'expo-router';
import {
    BodyLargeEmphasized,
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CircleAlertIcon,
    H6Regular,
    Icon,
    Private,
    Shadows,
    View,
    XStack,
    YStack,
} from 'smoothie';

const BillsChangesDetected = ({ billsCount, billsAmount }) => {
    return (
        <YStack
            gap={16}
            paddingVertical={20}
            paddingHorizontal={20}
            borderRadius="$5"
            borderWidth={1}
            borderColor="$gray200"
            flex={1}
            alignItems="center"
            backgroundColor="$white"
            {...Shadows.SMALL}
        >
            <BodyLargeEmphasized
                textAlign="left"
                width="100%"
                maxWidth="80vw" // helps prevent overflow on small devices like iPhone 13 mini
                paddingRight={20} // helps with text wrapping on common screen size
            >
                We&apos;ve detected some changes to your bills
            </BodyLargeEmphasized>

            <XStack gap={20} justifyContent="center" width="100%" flex={1}>
                <YStack
                    flex={1}
                    borderRadius="$5"
                    overflow="hidden"
                    borderWidth={1}
                    borderColor="$gray200"
                    paddingHorizontal={20}
                    paddingVertical={12}
                    justifyContent="center"
                    alignItems="center"
                    gap={4}
                >
                    <BodySmallRegular>Bills</BodySmallRegular>
                    <XStack justifyContent="center" alignItems="center" gap={0}>
                        <Private>
                            <H6Regular
                                justifyContent="center"
                                alignItems="center"
                                paddingRight={4}
                            >
                                {billsCount}
                            </H6Regular>
                        </Private>
                        <Icon icon={CircleAlertIcon} color="$orange1000" />
                    </XStack>
                </YStack>
                <YStack
                    flex={1}
                    borderRadius="$5"
                    overflow="hidden"
                    borderWidth={1}
                    borderColor="$gray200"
                    paddingHorizontal={20}
                    paddingVertical={12}
                    justifyContent="center"
                    alignItems="center"
                    gap={4}
                >
                    <BodySmallRegular>Monthly avg.</BodySmallRegular>
                    <XStack justifyContent="center" alignItems="center" gap={0}>
                        <Private>
                            <H6Regular
                                justifyContent="center"
                                alignItems="center"
                                paddingRight={4}
                            >
                                {billsAmount}
                            </H6Regular>
                        </Private>
                        <Icon icon={CircleAlertIcon} color="$orange1000" />
                    </XStack>
                </YStack>
            </XStack>
            <View width="100%">
                <Button
                    text="View bills"
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    onPress={() => {
                        router.navigate('/bills/bills-overview');
                    }}
                />
            </View>
        </YStack>
    );
};

export default BillsChangesDetected;
